import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './helpers/GlobalImports';
import { Layout } from './utility/context/Layout';
import * as serviceWorker from './serviceWorker';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/storeConfig/store';
import './helpers/JWTShare';
import './helpers/EmailToken';
import './helpers/PrototypeOverrides';
import Spinner from './components/@vuexy/spinner/Fallback-spinner';
import './index.scss';
import './index.css';
import './assets/@fortawesome/fontawesome-free/css/all.min.css';

const LazyApp = lazy(() => import('./App'));

// configureDatabase()
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Suspense fallback={<Spinner />}>
        <Layout>
          <LazyApp />
        </Layout>
      </Suspense>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
